import { render, staticRenderFns } from "./VideoPlaylists.vue?vue&type=template&id=d71502c0"
import script from "./VideoPlaylists.vue?vue&type=script&lang=js"
export * from "./VideoPlaylists.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports